export { MatchStatsLabel } from './MatchStatsLabel.component';
